import React, { useState, useEffect, useRef, useCallback, useMemo, } from 'react';
import { ListGroup, Form, Button, InputGroup } from 'react-bootstrap';
import { usePubNub } from 'pubnub-react';
import * as apicall from '../../components/Apicall';
import Loader from '../../components/Loader';
import { Link } from 'react-router-dom';

const colors = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark'];
const getColor = () => colors[Math.floor(Math.random() * colors.length)];
const timeFormate = (time) => {
  const messageDate = new Date(time); // no division
  return messageDate.toLocaleString([], {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).replace(' at ', ' ');
};


const Support = () => {
  const scrollRef = useRef(null);
  const pubnub = usePubNub();
  const listenerInitialized = useRef(false);

  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeUser, setActiveUser] = useState(null);
  const [newMessage, setNewMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [notificationsState, setNotifications] = useState({});
  const [activeChannel, setActiveChannel] = useState(null);
const [showMailModal, setShowMailModal] = useState(false);
const [supportMessage, setSupportMessage] = useState({ subject: "", content: "" });
const [errorSupportMessage, setErrorSupportMessage] = useState({ subject: false, content: false });
const [itemPics, setItemPics] = useState([]);
const [isRefresh, setIsRefresh] = useState(false);
const [loader, setLoader] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("user_details"));

const fileInputRef = useRef(null);
  const getUsersList = useCallback(async () => {
    setLoading(true);
    try {
      const res = await apicall.get('users_support_chatInfo');

      const uniqueUsers = res.data.reduce((acc, user) => {
      if (!acc.find((u) => u.id === user.id)) {
        acc.push(user);
      }
      return acc;
    }, []);
      const channelsListArray = uniqueUsers.map((user) => user.pubnub_channel_id);

      connectPubNub(channelsListArray);

      const usersList = await Promise.all(
        uniqueUsers.map(async (user) => {
          const messages = [];
          const msgResponse = await pubnub.fetchMessages({
            channels: [user.pubnub_channel_id],
            includeMessageActions: true,
            count: 100,
          });
          const message = msgResponse.channels[user.pubnub_channel_id];
          let startTimeToken = '';

          if (message && message.length > 0) {
            const fetchedMessages = message.map((msg) => ({
              sender: msg.uuid === user.pubnub_uuid ? 1 : 2,
              message: msg.message.description,
              time: timeFormate(msg.timetoken),
              timetoken: msg.timetoken,
            }));
            messages.push(...fetchedMessages);
            startTimeToken = message[message.length - 1]?.timetoken || '';
          }

          return {
  id: user.id,
  pubnub_uuid: user.pubnub_uuid,
  pubnub_channel_id: user.pubnub_channel_id,
  name: `${user.first_name}`,
  initial: user.first_name?.charAt(0),
  color: getColor(),
  messages,
  startTimeToken,
  status: user.status || "OPEN",
  last_message_role: user.last_message_role,
  unreadCount: 0
};

        })
      );

      const sortedList = usersList.sort((a, b) => b.startTimeToken - a.startTimeToken);

     setUsers(sortedList);

if (sortedList.length > 0) {
  setTimeout(() => {
    handleUserClick(sortedList[0]);
  }, 0); 
}
    //   setActiveUser(null);
    } catch (e) {
      console.error('Failed to fetch user list:', e);
    } finally {
      setLoading(false);
    }
  }, [pubnub]);
const mailsendFun = () => {
  setShowMailModal(!showMailModal);
  setSupportMessage({ subject: "", content: "" });
  setErrorSupportMessage({ subject: false, content: false });
  setItemPics([]);
  setLoader(false);
};
const updateChatStatus = async (userId, status) => {
  try {
    const body = {
      user_id: userId, 
      status,
      last_message_role:userDetails?.role
    }
   const res=  await apicall.post(body,'/update_support_status');
   window.location.reload();
  } catch (e) {
    console.error('Status update failed', e);
  }
};

const handleChange = (e, field) => {
  const value = e.target.value;
  const updated = { ...supportMessage, [field]: value };
  const errors = { ...errorSupportMessage };

  if (updated.subject.trim().length > 0) errors.subject = false;
  if (updated.content.trim().length > 0) errors.content = false;

  setSupportMessage(updated);
  setErrorSupportMessage(errors);
};

const selectImage = (e) => {
  const files = Array.from(e.target.files);
  const fileURLs = files.map((file) => URL.createObjectURL(file));
  setItemPics([...itemPics, ...fileURLs]);
  setIsRefresh(!isRefresh);
};

const deleteImage = (image) => {
  const updated = itemPics.filter((img) => img !== image);
  setItemPics(updated);
  setIsRefresh(!isRefresh);
};

const sendMail = async (selectedUser) => {
  let flag = true;
  let error = { ...errorSupportMessage };

  if (supportMessage.subject.trim().length === 0) {
    error.subject = true;
    flag = false;
  }
  if (supportMessage.content.trim().length === 0) {
    error.content = true;
    flag = false;
  }

  setErrorSupportMessage(error);

  if (!flag) return;

  try {
    setLoader(true);

    const allImages = await Promise.all(
      itemPics.map(async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();
        return await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });
      })
    );

    const data = {
      user_id: selectedUser?.id,
      subject: supportMessage.subject,
      content: supportMessage.content,
      allImages,
      role:"2"
    };
    const res = await apicall.post(data,"mobile_app_customer_support");
     if (res.status === 200 && res.success === true) {

  updateChatStatus(selectedUser.id, 'DONE');

  setUsers(prev =>
   prev.map(u =>
     u.id === selectedUser.id ? { ...u, status: 'DONE' } : u
   )
  );

 setActiveUser(prev => ({ ...prev, status: 'DONE' }));

  mailsendFun();
  setLoader(false);
  getUsersList();
}
 else {
      setLoader(false);
    }
  } catch (e) {
    setLoader(false);
  }
};

  const connectPubNub = useCallback(
    (channels) => {
      const newChannels = channels.filter(
        (channel) => !pubnub.getSubscribedChannels().includes(channel)
      );

      if (newChannels.length > 0) {
        pubnub.subscribe({ channels: newChannels });
      }
      if (!listenerInitialized.current) {
        pubnub.addListener({
          message: handleIncomingMessage,
        });
        listenerInitialized.current = true;
      }
    },
    [pubnub]
  );

  const handleIncomingMessage = (messageData) => {
    if (messageData.publisher === pubnub.getUUID()) return;
  
    setUsers((prevUsers) => {
      const userList = [...prevUsers];
      const index = userList.findIndex((user) => user.pubnub_channel_id === messageData.channel);
  
      if (index !== -1) {
        updateChatStatus(userList[index].id, 'OPEN');
         userList[index].status = 'OPEN';
        const newMessage = {
          sender: messageData.publisher === userList[index].pubnub_uuid ? 1 : 2,
          message: messageData.message.description,
          time: timeFormate(messageData.timetoken),
          timetoken: messageData.timetoken,
        };
  
        if (!userList[index].messages.some((msg) => msg.timetoken === newMessage.timetoken)) {
          userList[index].messages.push(newMessage);
          const updatedUser = userList.splice(index, 1)[0];
          userList.unshift(updatedUser);
        }
  
        if (activeChannel === messageData.channel) {
          resetNotificationsLocal(activeChannel);
          setTimeout(() => {
            scrollRef.current?.scrollIntoView({ behavior: 'smooth' });
          }, 100); // Ensure DOM updates before scrolling
        } else {
          setNotifications((prev) => ({
            ...prev,
            [messageData.channel]: (prev[messageData.channel] || 0) + 1,
          }));
        }
      }
  
      return userList;
    });
  };
  
  
  useEffect(() => {
    if (activeUser?.messages.length > 0) {
      setTimeout(() => {
        scrollRef.current?.scrollIntoView({ behavior: 'smooth' });
      }, 0); 
    }
  }, [activeUser?.messages]);
  
  
const getPlainText = (message) => {
  if (!message) return '';
  if (typeof message === 'string') return message;
  if (message.props?.children) {
    if (Array.isArray(message.props.children)) {
      return message.props.children.map(child => typeof child === 'string' ? child : '').join(' ');
    }
    if (typeof message.props.children === 'string') return message.props.children;
  }
  return '';
};

const handleUserClick = async (user) => {
  try {
    setActiveChannel(user.pubnub_channel_id);
    resetNotificationsLocal(user.pubnub_channel_id);

    const res = await apicall.get(`supportmessages/${user.id}`);
    const messagesArray = Array.isArray(res?.data) ? res.data : [];

const BASE_URL = 'https://dsh2wvf01gg7j.cloudfront.net/';

const userMessages = messagesArray.map((msg) => {
  const imageUrls = msg.image_url
    ? msg.image_url.split(',').map(url => url.trim()).map(url => url.startsWith('http') ? url : BASE_URL + url)
    : [];

  return {
    sender: msg.role === 2 ? 2 : 1,
    message: (
      <>
        Subject: {msg.subject} <br />
        Message: {msg.content} <br />
        {imageUrls.length > 0 && (
          <>
            Images:
            {imageUrls.map((url, idx) => (
              <React.Fragment key={idx}>
                <a 
                  href={url} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  style={{ color: 'black', textDecoration: 'underline' }}
                >
                  {url}
                </a>,
                <br />
              </React.Fragment>
            ))}
          </>
        )}
      </>
    ),
    time: timeFormate(msg.created),
    timetoken: new Date(msg.created).getTime(),
  };
});

setUsers((prevUsers) =>
  prevUsers.map((u) =>
    u.id === user.id ? { ...u, messages: [...userMessages] } : u
  )
);
setActiveUser((prev) => ({ ...user, messages: [...userMessages] }));

  } catch (err) {
    console.error("Failed to fetch support messages:", err);
  }
};

  const resetNotificationsLocal = (channel) => {
    setNotifications((prev) => ({
      ...prev,
      [channel]: 0,
    }));
  };
  


  const filteredData = useMemo(() => {
    return users.filter((user) =>
      user.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [searchTerm, users]);
  
const publishMessage = () => {
  if (newMessage.trim() && activeUser) {
    const tempMessage = {
      sender: 2,
      message: newMessage,
      time: timeFormate(Date.now() * 10000),
      timetoken: `${Date.now()}0000000`,
    };

    setUsers((prevUsers) => {
      const userList = [...prevUsers];
      const index = userList.findIndex((user) => user.id === activeUser.id);

      if (index !== -1) {
        userList[index].messages.push(tempMessage);
        const updatedUser = userList.splice(index, 1)[0];
        userList.unshift(updatedUser);
      }

      return userList;
    });

    // ✅ Update activeUser as well
    setActiveUser((prev) => ({
      ...prev,
      messages: [...prev.messages, tempMessage],
    }));

    pubnub.publish({
      channel: activeUser.pubnub_channel_id,
      message: { description: newMessage },
    }).then(() => {
      setNewMessage('');
      scrollRef.current?.scrollIntoView({ behavior: 'smooth' });
    });
  }
};

  useEffect(() => {
    getUsersList();

    return () => {
      pubnub.unsubscribeAll();
      pubnub.removeAllListeners();
    };
  }, [getUsersList, pubnub]);

  useEffect(() => {
    if (activeUser?.pubnub_channel_id) {
      resetNotificationsLocal(activeUser.pubnub_channel_id);
    }
  }, [activeUser, users]); 
  

  useEffect(() => {
    if (activeUser && activeUser.messages.length > 0) {
      scrollRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [activeUser?.messages]);
 
  return (
    <div style={{ overflow: 'hidden', height: '87vh' }}>
      {!loading ? (
        <div className="d-flex">
          <UserList
            users={filteredData}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            activeUser={activeUser}
            handleUserClick={handleUserClick}
            notificationsState={notificationsState}
            getPlainText={getPlainText}
          />
          <ChatArea
            activeUser={activeUser}
            newMessage={newMessage}
            setNewMessage={setNewMessage}
            setShowMailModal={setShowMailModal}
            showMailModal={showMailModal}
            supportMessage={supportMessage}
            setItemPics={setItemPics}
            setSupportMessage={setSupportMessage}
            sendMail={() => sendMail(activeUser)} 
            mailsendFun={mailsendFun}
            publishMessage={publishMessage}
            handleChange={handleChange}
            scrollRef={scrollRef}
            errorSupportMessage={errorSupportMessage}
            setErrorSupportMessage={setErrorSupportMessage}
            selectImage = {selectImage}
            deleteImage={deleteImage}
            itemPics={itemPics}
            loader={loader}
            fileInputRef={fileInputRef}
          />
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '88vh' }}>
          Loading...
        </div>
      )}
    </div>
  );
};

const UserList = ({ users, searchTerm, setSearchTerm, activeUser, handleUserClick, notificationsState,getPlainText }) => (
  <div className="col-3 border-end p-3 bg-white" style={{ overflowY: 'auto', height: '88vh' }}>
    <Form.Group className="mb-3">
      <InputGroup>
        <Form.Control
          type="text"
          placeholder="Search for users"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </InputGroup>
    </Form.Group>
    <ListGroup variant="flush">
      {users.map((user) => (
        <ListGroup.Item
          key={user.id}
          action
          onClick={() => handleUserClick(user)}
          active={user.id === activeUser?.id}
          className="user-item"
          style={{
            backgroundColor: user.id === activeUser?.id ? '#ffe4e4' : '',
            color: 'black',
          }}
        >
          <div className="d-flex align-items-center m-1">
            <div
              className={`bg-${user.color} text-white d-flex align-items-center justify-content-center`}
              style={{
                width: 40,
                height: 40,
                borderRadius: '5px',
                margin: '0 10px',
              }}
            >
              {user.initial}
            </div>
              <div className="ms-2">
              <p className="mb-0 small mt-1 d-flex align-items-center gap-2">
  {user.name}
  {user.status === 'DONE' ? (
    <span className="badge bg-success">Done</span>
  ) : (
    <span className="badge bg-warning text-dark">Open</span>
  )}
</p>

              <p
                className={`small mb-0 ${notificationsState[user.pubnub_channel_id] > 0 &&
                    user.pubnub_channel_id !== activeUser?.pubnub_channel_id
                    ? 'fw-bold'
                    : 'text-muted'
                  }`}
              >
               <p className="small mb-0 text-muted">
  {user.messages.length > 0
  ? getPlainText(user.messages[0].message).substring(0, 15) + '...'
  : 'No messages yet'}

</p>

              </p>


            </div>
            {notificationsState[user.pubnub_channel_id] > 0 && user.pubnub_channel_id !== activeUser?.pubnub_channel_id && (
              <span className="badge bg-danger ms-auto">
                {notificationsState[user.pubnub_channel_id]}
              </span>
            )}
          </div>
        </ListGroup.Item>
      ))}
    </ListGroup>
  </div>
);

const ChatArea = ({
  activeUser,
  newMessage,
  setNewMessage,
  publishMessage,
  scrollRef,
  supportMessage,
  handleChange,
  errorSupportMessage,
  loader,
  sendMail,
  deleteImage,
  itemPics,
  selectImage,
  setSupportMessage,
  setItemPics,
  fileInputRef
}) => (
 <div className="col-9 d-flex flex-column bg-white position-relative" style={{ height: '88vh' }}>
  <div className="border-bottom p-3 d-flex justify-content-between align-items-center">
    <h5 className="mb-0">{activeUser?.name}</h5>
  </div>

  <div className="flex-grow-1 p-3 overflow-auto">
    {activeUser?.messages
      .sort((a, b) => a.timetoken - b.timetoken)
      .map((msg) => (
        <div
          key={msg.timetoken}
          className={`d-flex flex-column align-items-${msg.sender === 2 ? 'end' : 'start'} mb-3`}
        >
         <div
  className={`p-2 w-50 ${
    msg.sender === 2 ? 'primaryBackground text-white' : 'bg-light'
  }`}
  style={{ borderRadius: '15px', wordWrap: 'break-word' }}
>
  <div className="d-flex justify-content-between align-items-center">
    <p className={`mb-0 fw-bold ${msg.sender === 2 ? 'text-white' : 'primaryColorText'}`}>
      {msg.sender === 2 ? 'Admin' : activeUser?.name}
    </p>
    <span className="small text-muted">
      {msg.time}
    </span>
  </div>

  <div className="mt-1">
    {msg.message}
  </div>
</div>

        </div>
      ))}
    <div ref={scrollRef}></div>
  </div>

  {/* Mail + Message Input at bottom */}
  <div className="border-top p-2" style={{ flexShrink: 0 }}>
    {/* Write message */}
    {/* <InputGroup className="mb-2">
      <Form.Control
        placeholder="Write your message"
        value={newMessage}
        onChange={(e) => setNewMessage(e.target.value)}
      />
      <Button type="submit" className="primaryBackground border-0">
        ➤
      </Button>
    </InputGroup> */}

   <div
  style={{
    maxHeight: '180px',
    overflowY: 'auto',
    padding: '5px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    background: '#fff',
    marginBottom: '5px',
  }}
>
  <Form.Group className="mb-1">
    <Form.Control
      type="text"
      placeholder="Subject"
      value={supportMessage.subject}
      onChange={(e) => handleChange(e, 'subject')}
      isInvalid={errorSupportMessage.subject}
      size="sm"
    />
    {errorSupportMessage.subject && (
      <Form.Text className="text-danger">Enter subject for a mail.</Form.Text>
    )}
  </Form.Group>

  <Form.Group className="mb-1">
    <Form.Control
      as="textarea"
      rows={2}
      placeholder="Message"
      value={supportMessage.content}
      onChange={(e) => handleChange(e, 'content')}
      isInvalid={errorSupportMessage.content}
      size="sm"
    />
    {errorSupportMessage.content && (
      <Form.Text className="text-danger">Enter message for a mail.</Form.Text>
    )}
  </Form.Group>

<Form.Group className="mb-1">
  <Form.Control
    ref={fileInputRef}
    type="file"
    multiple
    accept="image/*"
    onChange={selectImage}
    size="sm"
  />

  <div className="d-flex flex-wrap mt-1" style={{ maxHeight: '50px', overflowY: 'auto' }}>
    {itemPics.map((img, idx) => (
      <div
        key={idx}
        className="position-relative me-1 mb-1"
        style={{ width: 40, height: 40 }}
      >
        <img
          src={img}
          alt="preview"
          className="img-thumbnail"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
        <button
          type="button"
          className="btn btn-sm btn-danger position-absolute top-0 end-0 p-0"
          onClick={() => deleteImage(img)}
          style={{ fontSize: '9px', width: '16px', height: '16px' }}
        >
          ✕
        </button>
      </div>
    ))}
  </div>
</Form.Group>

  <div className="d-flex justify-content-end">
  <button
    type="button"
    onClick={() => {
      setSupportMessage({ subject: '', content: '' });
      setItemPics([]);
      if (fileInputRef.current) {
        fileInputRef.current.value = ''; 
      }
    }}
    className="btn btn-sm primaryBackground text-white"
    style={{ width: '70px', height: '28px', fontSize: '12px', marginRight: '10px' }}
  >
    Clear
  </button>

  <button
    onClick={sendMail}
    className="btn btn-sm primaryBackground text-white"
    style={{ width: '70px', height: '28px', fontSize: '12px' }}
  >
    {loader ? <Loader style={{ height: '18px', width: '25px' }} /> : 'Send'}
  </button>
</div>
</div>

  </div>
</div>

);




export default Support;